import React from 'react';
import { Center, CircularProgress, Text, VStack } from '@wegroup/design-system';
// import QuestionViewSkeleton from '../../../../../../../sales-conversation/src/components/skeletons/QuestionViewSkeleton';
import AdvisoryAppShell from './AdvisoryAppShell';
import { useTranslation } from 'react-i18next';

const AdvisoryFlowLoading: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  return (
    <AdvisoryAppShell>
      {/* <QuestionViewSkeleton /> */}
      <Center h="100%" w="100%">
        <VStack spacing="2">
          <CircularProgress size="28" color="primary.500" isIndeterminate />
          <Text>{t('ADVISORY_FLOW_LOADING_TEXT')}...</Text>
        </VStack>
      </Center>
    </AdvisoryAppShell>
  );
};

export default AdvisoryFlowLoading;
